export default function ValidationMessage({ message, className }) {
    return (
        <>
            {message ? (
                <span
                    className={
                        className
                            ? className
                            : "text-xs italic text-red-700 mt-1"
                    }
                >
                    {message ? message : "message undefined"}
                </span>
            ) : null}
        </>
    );
}
